import script from "./ArticleSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./ArticleSummary.vue?vue&type=script&setup=true&lang=js"

import "./ArticleSummary.vue?vue&type=style&index=0&id=1866a14d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1866a14d"]])

export default __exports__